import React from 'react';
import PropTypes from 'prop-types';
import { GroupHeader } from './GroupHeader.styles';

/**
 * Manages the styles for the given grouping element.
 * @param {props} a set of props to be render.
 * @returns a Group header style, empty if grouping name is not valid.
 */
export const GroupNamesHandling = ({ props }) => {
  const { group, children } = props;
  if (children && children.length === 1) {
    const {
      props: {
        option: { label: childLabel, locationId: billSite },
      },
    } = children[0];

    const locationGroup = `${billSite} - ${childLabel}`;

    if (group && group === locationGroup) {
      return <></>;
    }
  }
  return <GroupHeader>{group}</GroupHeader>;
};

GroupNamesHandling.propTypes = {
  props: PropTypes.object.isRequired,
  group: PropTypes.string,
  children: PropTypes.array,
};

export default GroupNamesHandling;
